/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crosspostingimages1Inputs */

const en_crosspostingimages1 = /** @type {(inputs: Crosspostingimages1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Images`)
};

const de_crosspostingimages1 = /** @type {(inputs: Crosspostingimages1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bilder`)
};

/**
* | output |
* | --- |
* | "Images" |
*
* @param {Crosspostingimages1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const crosspostingimages1 = /** @type {((inputs?: Crosspostingimages1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crosspostingimages1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crosspostingimages1(inputs)
	return de_crosspostingimages1(inputs)
});
export { crosspostingimages1 as "crosspostingImages" }